<template>

  <section>
    <div class="container">
      <div class="row vh-100 d-flex align-items-center justify-content-center">
  
        <div class="row">
          <div class="col-md-12 d-flex justify-content-center mb-5">
          <img class="logo" src="@/assets/logo-dikey.svg" alt="">
  
          </div>
  
          <div class="col-md-12 d-flex justify-content-center mb-3">
            <p><strong>Lütfen Dil Seçmi Yapın</strong> | <span class="thin">Please Choose a Language</span></p>
          </div>
          <div class="d-none d-lg-block col-lg-3 mb-3">
          </div>
          <div v-for="(item, index) in kayitlar" :key="index" class="col-md-6 col-lg-3 d-flex justify-content-center mb-3">
            <a class="dilbuton" :href="'https://api.adalarvakfi.org/muze-sesli-icerik/'+id+'-'+item.dilcode+item.dosya_tur">{{ buton_label(index) }}</a>
          </div>
  
          <div class="col-md-12 d-flex justify-content-center mb-3">
            <a :href="instagram" target="_blank"><img class="sosyal-medya-ikonlari" src="@/assets/icon-instagram.svg" alt=""></a>
            <a :href="facebook" target="_blank"><img class="sosyal-medya-ikonlari" src="@/assets/icon-facebook.svg" alt=""></a>
            <a :href="youtube" target="_blank"><img class="sosyal-medya-ikonlari" src="@/assets/icon-youtube.svg" alt=""></a>
            <a :href="twitter" target="_blank"><img class="sosyal-medya-ikonlari" src="@/assets/icon-twitter.svg" alt=""></a>
          </div>
        </div>
        </div>
      </div>
      <div class="fixed-bottom d-flex justify-content-center"><a class="extrarenk" :href="extrarenk" target="_blank">ExtraRenk Tasarım ve Yazılım Çözümleri</a></div>
  </section>
  
  </template>
  
  
  <script>
  
  export default({
    name:'HOME',
    data (){
      return {
        facebook:'https://www.facebook.com/AdalarMuzesi/',
        instagram:'https://www.instagram.com/adalar_muzesi/',
        twitter:'https://twitter.com/adalarmuzesi',
        youtube:'https://www.youtube.com/c/AdalarMuzesi',
        extrarenk:'https://bit.ly/ExtraRenk',
        id:null,
        kayitlar:[
          {
            'dilcode':'tr',
            'dosya_tur':'.mp3'
          },
          {
            'dilcode':'en',
            'dosya_tur':'.mp3'
          }
        ]
      }
    },
    created(){
      this.get_id()
    },
    methods: {
      get_id:function(){
        const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
        });
      // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
      this.id = params.id;
  
      },
      buton_label (index){
        const dilcode = this.kayitlar[index].dilcode
        var label
        if (dilcode === 'tr'){
          label = "TÜRKÇE"
        } else if (dilcode === 'en'){
           label = "ENGLISH"
        }
        return label
      }
    }
  })
  </script>
  
  <style scoped>
  @import url("https://use.typekit.net/ypx7idz.css");
  body, p{
  font-family: "proxima-nova", sans-serif;
  font-weight: 400;
  font-style: normal;
  }
  
  strong{
  font-family: "proxima-nova", sans-serif;
  font-weight: 700;
  font-style: normal;
  }
  .italic{
    font-family: "proxima-nova", sans-serif;
  font-weight: 400;
  font-style: italic;
  }
  
  .italic{
  font-family: proxima-nova, sans-serif;
  font-weight: 100;
  font-style: normal;
  }
  .dilbuton{
    width: 300px;
    padding: 10px;
    text-align: center;
    text-decoration: none;
    color:rgb(27, 29, 33);
    background-color: aqua;
  }
  .logo{
    width: 100px;
  }
  hr{
    width: 100%;
    display: block;
  }
  .sosyal-medya-ikonlari:nth-child(1){
    margin-left: 22px;
  }
  .sosyal-medya-ikonlari{
    margin-right: 22px; margin-top: 68px;
  }
  .extrarenk{
    margin-bottom: 16px;
    font-size: 12px;
    color: rgba(0,0,0,0.5);
    text-decoration: none;
  }
  </style>
  